import { render } from "./zqTopicInfo.vue?vue&type=template&id=a8dbe82e&scoped=true"
import script from "./zqTopicInfo.vue?vue&type=script&lang=js"
export * from "./zqTopicInfo.vue?vue&type=script&lang=js"

import "./zqTopicInfo.vue?vue&type=style&index=0&id=a8dbe82e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8dbe82e"]])

export default __exports__